import { ENTER } from '@angular/cdk/keycodes';
import {
    ChangeDetectionStrategy,
    Component,
    HostListener,
    Inject,
    TemplateRef,
    ViewEncapsulation
} from '@angular/core';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';

export class ConfirmDialogData {
    body ? = '';
    paragraphs ?: string[];
    bodyTemplate ?: TemplateRef<any> = null;
    bodyTemplateContext ?: any = null;
    submitLabel ? = 'Valider';
    cancelLabel ? = 'Annuler';
    accepted ? = false;

    constructor(config?: ConfirmDialogData) {
        if (config) {
            Object.keys(config)
                .filter(key => typeof config[key] !== 'undefined')
                .forEach(key => this[key] = config[key]);
        }
    }
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ConfirmDialogComponent {

    constructor(private dialogRef: KalDialogRef<ConfirmDialogComponent>,
                @Inject(KAL_DIALOG_DATA) public data: ConfirmDialogData) {

        if (data && (Object.keys(data).length === 0 || (!data.submitLabel && !data.cancelLabel))) {
            this.data = new ConfirmDialogData({
                body: data?.body,
                bodyTemplate: data?.bodyTemplate,
                paragraphs: data?.paragraphs,
                accepted: data?.accepted
            });
        }
    }

    @HostListener('document:keyup', ['$event'])
    enter(event: KeyboardEvent): void {
        if (event.keyCode === ENTER) {
            event.stopPropagation();
            this.submitDialog();
        }
    }

    /**
     * submit dialog
     */
    submitDialog(): void {
        this.data.accepted = true;
        this.dialogRef.close(this.data);
    }

    /**
     * cancel dialog
     */
    cancelDialog(): void {
        this.data.accepted = false;
        this.dialogRef.close(this.data);
    }
}
